<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة طلب توثيق عقد</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/propertyDocs">توثيق العقود</router-link></li>
              <li class="breadcrumb-item active">إضافة طلب</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header"><div class="card-title">إضافة طلب توثيق عقد</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSuccess" :message="message" />

              <form @submit.prevent="submitData()">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">جوال العميل: <span class="req">*</span></label>
                      <input type="text" class="form-control" placeholder="جوال العميل المسجل" @keyup="getClientData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label">اسم العميل:</label>
                        <div class="fw-bold">{{ userName }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">اسم مقدم الطلب: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="name">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">رقم جوال التواصل: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="mobile">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">نوع التوثيق:</label>
                      <select class="form-control" v-model="priceId">
                        <option :value="null">اختر النوع</option>
                        <option v-for="p in priceOptions" :value="p.id" :key="p.id">
                          {{ p.name }} ({{ p.price }} ر.س)
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">ملاحظات الإدارة:</label>
                      <textarea class="form-control" rows="3" v-model="adminNotice" placeholder="ملاحظات..."></textarea>
                    </div>
                  </div>

                  <div class="alert alert-info">
                    <i class="bi bi-info-circle me-1"></i>
                    سيتم إضافة الطلب بحالة "غير مدفوع" ويمكن تعديل حالة الدفع لاحقاً.
                  </div>
                </div>

                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">إضافة</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'PropertyDocsCreate',
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSuccess: false,
      message: '',
      errorNumber: 0,

      userMobile: null,
      userId: null,
      userName: null,
      userLoader: false,

      name: null,
      mobile: null,
      priceId: null,
      adminNotice: null,
      priceOptions: [],
    }
  },
  methods: {
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          if(!this.name) this.name = data.user.name;
          if(!this.mobile) this.mobile = data.user.mobile;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    getInitData(){
      this.$http.get('/api/admin/propertyDoc/init').then(({data}) => {
        this.priceOptions = data.priceOptions ?? [];
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    submitData(){
      this.hasError = false;
      this.hasSuccess = false;

      if(!this.userId){
        this.message = 'يجب تحديد العميل عن طريق رقم الجوال أولاً';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if(!this.name || !this.mobile){
        this.message = 'يرجى تعبئة اسم مقدم الطلب ورقم جواله';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      this.formLoader = true;
      this.$http.post('/api/admin/propertyDoc/create', {
        userId: this.userId,
        name: this.name,
        mobile: this.mobile,
        priceId: this.priceId,
        adminNotice: this.adminNotice,
      }).then(({data}) => {
        toast('تم إضافة الطلب بنجاح', 'success');
        this.$router.push(`/propertyDocs/update/${data.row.id}`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    this.getInitData();
  }
}
</script>